import { createSlice } from "@reduxjs/toolkit";

export const addPartnerFeeSlice = createSlice({
  name: "addPartnerFee",
  initialState: {
    lockerTypeAndPartnerType: {
      lockerTypeId: "-1",
      partnerTypeId: "-1",
      partnerCategoryNo: "-1", // Added for partner category
      pickupPulloutLimit: null,
    },
    partnerTypesList: [],
    lockerTypesList: [],
    doorSizesList: [],
    //For Dropoff cost
    addDropoffCostItem: [],
    // For Package Shipout Return
    addPackageShipoutCostItem: [],
  },
  reducers: {
    handleChangeLockerTypeAndPartnerTypeReducer: (state, actions) => {
      const { name, value, pickupPulloutLimit } = actions.payload;
      const tempVar = { ...state.lockerTypeAndPartnerType };
      tempVar[name] = value;
      // Save pickupPulloutLimit if provided
      if (pickupPulloutLimit !== undefined) {
        tempVar.pickupPulloutLimit = pickupPulloutLimit;
      }

      state.lockerTypeAndPartnerType = tempVar;
      // Lists
      let tempDropoffCostItem = [...state.addDropoffCostItem];
      tempDropoffCostItem.forEach((element, key) => {
        tempDropoffCostItem[key][name] = value;
      });
      let tempPackageShipoutCostItem = [...state.addPackageShipoutCostItem];
      tempPackageShipoutCostItem.forEach((element, key) => {
        tempPackageShipoutCostItem[key][name] = value;
      });
    },
    setDoorSizesList: (state, actions) => {
      state.doorSizesList = actions.payload;
    },
    setPartnerTypeList: (state, actions) => {
      state.partnerTypesList = actions.payload;
    },
    setLockerTypeList: (state, actions) => {
      state.lockerTypesList = actions.payload;
    },
    // For Dropoff Cost
    handleAddDropoffCostItemReducer: (state, actions) => {
      let tempVar = [...state.addDropoffCostItem];
      tempVar.push(actions.payload);
      state.addDropoffCostItem = tempVar;
    },
    handleEditAddedDropoffCostItemReducer: (state, actions) => {
      const { name, value, id } = actions.payload;
      const tempVar = [...state.addDropoffCostItem];
      tempVar[id][name] = value;
      state.addDropoffCostItem = tempVar;
    },
    // For Package Shipout Cost
    handleAddPackageShipoutCostItemReducer: (state, actions) => {
      let tempVar = [...state.addPackageShipoutCostItem];
      tempVar.push(actions.payload);
      state.addPackageShipoutCostItem = tempVar;
    },
    handleEditAddedPackageShipoutCostItemReducer: (state, actions) => {
      const { name, value, id } = actions.payload;
      const tempVar = [...state.addPackageShipoutCostItem];
      tempVar[id][name] = value;
      state.addPackageShipoutCostItem = tempVar;
    },

    //This Clear all the list and return the values into default
    handelCancelChagesReducer: (state) => {
      state.lockerTypeAndPartnerType = {
        lockerTypeId: "-1",
        partnerTypeId: "-1",
        partnerCategoryNo: "-1",
        pickupPulloutLimit: null,
      };
      state.addDropoffCostItem = [];
      state.addPackageShipoutCostItem = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  handleChangeLockerTypeAndPartnerTypeReducer,
  setDoorSizesList,
  setPartnerTypeList,
  setLockerTypeList,
  // For dropoff
  handleAddDropoffCostItemReducer,
  handleEditAddedDropoffCostItemReducer,
  // For Package Shipout Cost
  handleAddPackageShipoutCostItemReducer,
  handleEditAddedPackageShipoutCostItemReducer,
  // For Cancelation
  handelCancelChagesReducer,
} = addPartnerFeeSlice.actions;

export default addPartnerFeeSlice.reducer;
